import { render, staticRenderFns } from "./roleState.vue?vue&type=template&id=56b71d78&scoped=true"
import script from "./roleState.vue?vue&type=script&setup=true&lang=js"
export * from "./roleState.vue?vue&type=script&setup=true&lang=js"
import style0 from "./roleState.vue?vue&type=style&index=0&id=56b71d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b71d78",
  null
  
)

export default component.exports